import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettlementsService } from 'src/app/services/settlements.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ValidateConfirmpass } from 'src/app/components/confirmpass.validator';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { IconsService } from 'src/app/shared/services/icons.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { User } from 'src/app/models/user';
import { Role } from 'src/app/models/role.model';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-profile',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Perfiles y roles</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">
        <ul #subnav app-nav-administration [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill" style="max-width: 380px;">   
        <div class="list-group rounded-4 rounded-md-5">
          <div class="list-group-item table-responsive py-4">
            <app-form-user [user]="user" [roles]="roles" (updateUser)="saveUser($event)"></app-form-user>
          </div>
        </div>
      </div>
      <div class="ms-2 flex-fill">
        <div class="list-group rounded-4 rounded-md-5">
          <div class="list-group-item table-responsive py-4">
            <form [formGroup]="passwordForm" (ngSubmit)="updatePassword()">
              <div class="form-group required mt-4">
                <label for="password" class="form-label ms-2">Contraseña</label>
                <div class="input-group">
                  <input
                    id="password"
                    [type]="showPassword ? 'text' : 'password'"
                    formControlName="password"
                    class="form-control form-control-lg rounded-3 rounded-end-0 pt-3 pb-3 border-end-0"
                    placeholder="Contraseña"
                  >
                  <span class="input-group-append bg-white border-start-0">
                    <span class="input-group-text bg-transparent rounded-3 rounded-start-0 pt-3 pb-4 border-start-0 ">
                      <!-- i class="icon ion-ios-search"></!-->
                      <fa-icon (click)="togglePassword()" *ngIf="showPassword" [icon]="icons.faEye" class="text-dark me-2"></fa-icon>
                      <fa-icon (click)="togglePassword()" *ngIf="!showPassword" [icon]="icons.faEyeSlash" class="text-dark me-2"></fa-icon>
                    </span>
                  </span>
                </div>
              </div>
              <div class="form-group required mt-4">
                <label for="password_confirmation" class="form-label ms-2">Confirmar contraseña</label>
                <input type="text" formControlName="password_confirmation" class="form-control form-control-lg" id="password_confirmation" placeholder="">
              </div>

              <div class="form-group mt-4">
                <password-strength-meter [password]="passwordForm.value.password"></password-strength-meter>
              </div>
              <small id="passwordHelpBlock" class="form-text text-muted text-start text-sm">
                Su contraseña debe tener entre 8 y 20 caracteres, contener letras, números, caracteres especiales, y no debe contener espacios, ni emojis.
              </small>

              <div *ngIf="lf['password'].touched && lf['password'].invalid" class="text-start">
                <div *ngIf="lf['password'].errors?.['required']" class="text-danger text-sm">La contraseña es requerido.</div>
                <small *ngIf="lf['password'].errors?.['minlength']" class="text-danger text-sm">La contraseña contener un mínimo 8 caracteres.</small>
                <small *ngIf="lf['password'].errors?.['maxlength']" class="text-danger text-sm">La contraseña contener un máximo 20 caracteres.</small>
                <small *ngIf="!lf['password'].errors?.['minlength'] && lf['password'].errors?.['pattern']" class="text-danger text-sm">La contraseña debe contener al menos un número (0-9), al menos una letra minúscula (a-z), al menos una letra mayúscula (A-Z), y al menos un caracter especial ($&#64;#!%*?&)</small>
              </div>
              <div *ngIf="lf['password_confirmation'].touched && lf['password_confirmation'].invalid" class="text-start">
                <div *ngIf="lf['password_confirmation'].errors?.['required']" class="text-danger text-sm">La confirmación de la contraseña es requerida.</div>
                <small *ngIf="lf['password_confirmation'].errors?.['noMatch']" class="text-danger text-sm">Las contraseñas deben coincidir.</small>
              </div>

              <div class="form-group mt-3 text-end">
                <button type="submit" class="btn btn-zazz-dark">Actualizar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class ProfileComponent implements OnInit {
  storageService = inject(StorageService);
  userId: number = 0;
  user: User | null = null;
  roles: Role[] = [];
  showPassword: boolean = false;
  passwordForm: FormGroup = new FormGroup({});
  profile: any = sessionStorage.getItem(STORAGE_KEYS.PROFILE) ? JSON.parse(sessionStorage.getItem(STORAGE_KEYS.PROFILE)!).profile : null;
  currentView: string = 'users';

  constructor(
    private store: SettlementsService,
    private route: Router,
    private activateRoute: ActivatedRoute,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public icons: IconsService,
    public authService: AuthService
  ) { 
    this.activateRoute.params.subscribe(params => {
      this.userId = params['id'];
      this.loadUser(this.userId);
    });

    this.store.getRoles({}).subscribe({
      next: (data: any) => {
        this.roles = data;
      },
      error: (error: any) => {}
    });
  }
  
  ngOnInit(): void {
    this.initForm();
  }

  get lf() {
    return this.passwordForm.controls;
  }

  initForm() {
    this.passwordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(20), Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@#!%*?&])[A-Za-z\d$@$!%*?&].{8,}')]],
      password_confirmation: ['', [Validators.required, ValidateConfirmpass]]
    });
  }

  loadUser(id: number) {
    this.store.getUser(id).subscribe({
      next: (data: any) => {
        console.log("data => ", data);
        this.user = data;
        // this.buildForm();
      },
      error: (error: any) => {}
    });
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  saveUser(user: any) {
    console.log('user!!!! => ', user);
    this.store.updateUser(this.userId, user).subscribe({
      next: (data: any) => {
        console.log('data => ', data);
        this.toastr.success('Éxito', 'Usuario actualizado correctamente.');
        this.route.navigate(['users']);
      },
      error: (error: any) => {
        console.log('error => ', error);
        this.toastr.error('Error', 'Ocurrió un error al actualizar el usuario');
      }
    });
  }

  updatePassword() {
    this.store.updateUser(this.userId, this.passwordForm.value).subscribe({
      next: (data: any) => {
        console.log('data => ', data);
        this.toastr.success('Éxito', 'Contraseña actualizada correctamente.');
      },
      error: (error: any) => {
        console.log('error => ', error);
        this.toastr.error('Error', 'Ocurrió un error al actualizar la contraseña');
      }
    });

  }
  
}
